import React, { Component } from 'react';

import '../../index.css';
import icDown from '../../icons/ic-down.png';
import icUp from '../../icons/ic-up.png';
import Title from '../../components/Title';

function MyPageServiceInfo() {
  const [isTableVisible, setTableVisible] = React.useState(false);
  return (
    <div>
      <Title title="서비스 안내" />
      <div
        style={{
          overflow: 'hidden',
          border: '1px solid #848484',
          borderRadius: 5,
          width: 750,
          marginTop: 46,
        }}
      >
        <table style={{ borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td
                style={{
                  width: 160,
                  height: 80,
                  backgroundColor: 'rgba(255, 182, 0, .4)',
                  textAlign: 'center',
                  border: '1px solid #848484',
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                무료 <br />
                요금제
              </td>

              <td
                style={{ width: 620, height: 80, border: '1px solid #848484' }}
              >
                <p
                  style={{
                    padding: 15,
                    borderBottom: '1px solid #CCCCCC',
                    fontSize: 16,
                    fontWeight: 400,
                  }}
                >
                  무료
                </p>
                <p style={{ padding: 15, fontSize: 16, fontWeight: 400 }}>
                  사용기간 : 무제한
                </p>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  width: 160,
                  height: 80,
                  backgroundColor: 'rgba(255, 182, 0, .8)',
                  textAlign: 'center',
                  border: '1px solid #848484',
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                유료 <br />
                요금제
              </td>
              <td
                style={{
                  padding: 15,
                  width: 620,
                  height: 80,
                  border: '1px solid #848484',
                  fontSize: 16,
                  fontWeight: 400,
                }}
              >
                월 가격 : 77,000원 (VAT 포함)
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '26px',
          marginRight: 15,
          justifyContent: 'flex-end',
        }}
      >
        <div
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => {
            setTableVisible(!isTableVisible);
          }}
        >
          상세 보기
        </div>
        <img
          src={isTableVisible ? icUp : icDown}
          style={{
            width: 20,
            height: 20,
            marginTop: 3,
            marginLeft: 5,
          }}
        />
      </div>

      {isTableVisible && (
        <div
          style={{
            overflow: 'hidden',
            border: '0.43px solid #C2C2CD',
            borderRadius: 12.9,
            width: 752,
            marginTop: 16,
            marginBottom: 70,
          }}
        >
          <table style={{ borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: 130,
                    height: 41.5,
                    backgroundColor: '#7F7F87',
                    textAlign: 'center',
                    color: 'white',
                    fontSize: '17px',
                  }}
                >
                  분류
                </td>

                <td
                  style={{
                    width: 270,
                    height: 41.5,
                    backgroundColor: '#7F7F87',
                    textAlign: 'center',
                    color: 'white',
                    fontSize: '17px',
                    fontWeight: 500,
                  }}
                >
                  기능
                </td>
                <td
                  style={{
                    width: 185,
                    height: 41.5,
                    backgroundColor: '#7F7F87',
                    textAlign: 'center',
                    color: 'white',
                    fontSize: '17px',
                    fontWeight: 500,
                  }}
                >
                  무료 요금제
                </td>
                <td
                  style={{
                    width: 185,
                    height: 41.5,
                    backgroundColor: '#7F7F87',
                    textAlign: 'center',
                    color: 'white',
                    fontSize: '17px',
                  }}
                >
                  유료 요금제
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    width: 130,
                    height: 140,
                    textAlign: 'center',
                    fontSize: '17px',
                  }}
                >
                  콘텐츠
                </td>
                <td style={{ width: 270, height: 140 }}>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    제작할 수 있는 콘텐츠의 수
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    노출할 수 있는 콘텐츠의 수
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    디자인 테마 사용
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    연동가능한 상품의 수
                  </p>
                </td>

                <td style={{ width: 180, height: 140 }}>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    10개
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    PC, 모바일 각각 1개
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    폰트만
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    20개
                  </p>
                </td>

                <td style={{ width: 180, height: 140 }}>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    무제한
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    무제한
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    모든 디자인 요소
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    무제한
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    width: 130,

                    backgroundColor: '#F9F9FA',
                    textAlign: 'center',
                    fontSize: '17px',
                  }}
                >
                  추가지원
                </td>
                <td style={{ width: 270, height: 140 }}>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    PC 쇼핑몰 적용 가능
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    모바일 쇼핑몰 적용 가능
                  </p>

                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                    }}
                  >
                    통계 서비스 지원
                  </p>
                </td>

                <td style={{ width: 180, height: 140 }}>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    콘텐츠 1개
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    콘텐츠 1개
                  </p>

                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                    }}
                  >
                    ○
                  </p>
                </td>

                <td style={{ width: 180, height: 140 }}>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                    }}
                  >
                    무제한
                  </p>
                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                      borderBottom: '0.43px solid #C2C2CD',
                      backgroundColor: '#F9F9FA',
                    }}
                  >
                    무제한
                  </p>

                  <p
                    style={{
                      padding: 10,
                      textAlign: 'center',
                    }}
                  >
                    ○
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default MyPageServiceInfo;
